"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.EuropaRebalanced = void 0;
var Colony_1 = require("./Colony");
var Resources_1 = require("../Resources");
var ColonyName_1 = require("./ColonyName");
var ColonyBenefit_1 = require("./ColonyBenefit");
var EuropaRebalanced = (function (_super) {
    __extends(EuropaRebalanced, _super);
    function EuropaRebalanced() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = ColonyName_1.ColonyName.EUROPA_REBALANCED;
        _this.description = 'Production';
        _this.buildType = ColonyBenefit_1.ColonyBenefit.PLACE_OCEAN_TILE;
        _this.tradeType = ColonyBenefit_1.ColonyBenefit.GAIN_PRODUCTION;
        _this.tradeQuantity = [1, 1, 1, 1, 1, 2, 2];
        _this.tradeResource = [
            Resources_1.Resources.MEGACREDITS, Resources_1.Resources.MEGACREDITS,
            Resources_1.Resources.ENERGY, Resources_1.Resources.ENERGY, Resources_1.Resources.ENERGY,
            Resources_1.Resources.ENERGY, Resources_1.Resources.ENERGY,
        ];
        _this.colonyBonusType = ColonyBenefit_1.ColonyBenefit.GAIN_RESOURCES;
        _this.colonyBonusQuantity = 2;
        _this.colonyBonusResource = Resources_1.Resources.MEGACREDITS;
        _this.shouldIncreaseTrack = Colony_1.ShouldIncreaseTrack.ASK;
        return _this;
    }
    return EuropaRebalanced;
}(Colony_1.Colony));
exports.EuropaRebalanced = EuropaRebalanced;
//# sourceMappingURL=EuropaRebalanced.js.map